import { P2GBadge } from '@parcel2go/core-ui';
import { P2GBox } from '@parcel2go/core-ui';
import { makeStyles } from 'tss-react/mui';
import { ReactNode } from 'react';

import { SmallText } from './SmallText';
import CdnIconProxy from '~/apps/account-linking/components/CdnIconProxy';

// Needs moving to css file.
const useStyles = makeStyles()(() => ({
  root: {
    marginBottom: '5px',
    transition: 'all 0.3s ease-in-out',
    '&:hover': {
      opacity: 0.5,
      cursor: 'pointer'
    }
  }
}));

interface props {
  text: string;
  icon: ReactNode;
  iconSrc?: string;
  count?: number;
  onClick?: () => void;
}

const ActionIcon: React.FC<props> = (props) => {
  const classes = useStyles();
  return (
    <P2GBox onClick={props.onClick}>
      <P2GBox classNames={classes.classes.root}>
        {props.count ? (
          <P2GBadge badgeContent={props.count} colour="primary">
            <CdnIconProxy size="sm" palette="primary" src={props.iconSrc}>
              {props.icon}
            </CdnIconProxy>
          </P2GBadge>
        ) : (
          <CdnIconProxy size="sm" palette="primary" src={props.iconSrc}>
            {props.icon}
          </CdnIconProxy>
        )}
      </P2GBox>
      {SmallText(props.text)}
    </P2GBox>
  );
};

export default ActionIcon;
